import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class SlackOAuthId extends IdValueObject {
  static create(value: string): SlackOAuthId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new SlackOAuthId(value);
  }
}
